import { DatePicker } from "antd";
import React, { memo, useCallback } from "react";
import moment from "moment";

const SelectMonth = ({ setFieldsValue, name }) => {
  const onChange = useCallback(
    (date) => {
      !!setFieldsValue &&
        setFieldsValue({
          [name]: date,
        });
    },
    [setFieldsValue, name]
  );

  return (
    <DatePicker
      onChange={onChange}
      defaultValue={moment()}
      style={{ width: "100%" }}
      placeholder="Chọn tháng"
      format="MM/YYYY"
      picker="month"
    />
  );
};

export default memo(SelectMonth);
